import { conventionsApi } from "../store/api/conventionsApi";
import { runMutation, runQuery } from "../store/api/runtime";

export type ConventionEvent = {
  id: string;
  primaryId?: string;
  sourceIds?: string[];
  name: string;
  venueName?: string;
  address?: string;
  city?: string;
  state?: string;
  countryCode?: string;
  zipCode?: string;
  latitude?: number | null;
  longitude?: number | null;
  startDate?: string;
  endDate?: string;
  startDateTime?: string;
  endDateTime?: string;
  description?: string;
  games?: string[];
  website?: string;
  eventType?: string;
  distanceMiles?: number | null;
  groupedStartDate?: string;
  groupedEndDate?: string;
  dayCount?: number;
};

export type ConventionsQuery = {
  zipCode?: string;
  countryCode?: string;
  lat?: number;
  lng?: number;
  radius?: number;
  month?: number;
  year?: number;
  startDate?: string;
  endDate?: string;
  games?: string[] | string;
  eventType?: string;
  sort?: "date_asc" | "date_desc" | "distance";
  limit?: number;
  cursor?: string;
};

export type ConventionLocationResolution = {
  zipCode: string;
  countryCode: string;
  lat: number;
  lng: number;
  label: string;
};

export type ConventionFavorite = {
  id: string;
  userId: string;
  conventionId: string;
  addedAt: string;
  reminderEnabled?: boolean;
  reminderAt?: string | null;
  reminderLeadDays?: number | null;
  reminderNotifiedAt?: string | null;
};

export async function getConventions(params?: ConventionsQuery): Promise<ConventionEvent[]> {
  return runQuery(conventionsApi.endpoints.getConventions.initiate, params);
}

export async function resolveConventionLocation(
  params: { zipCode: string; countryCode?: string },
): Promise<ConventionLocationResolution> {
  return runQuery(conventionsApi.endpoints.resolveConventionLocation.initiate, params);
}

export async function getConventionById(id: string): Promise<ConventionEvent> {
  return runQuery(conventionsApi.endpoints.getConventionById.initiate, id);
}

export async function getConventionFavorites(userId: string): Promise<ConventionFavorite[]> {
  return runQuery(conventionsApi.endpoints.getConventionFavorites.initiate, userId);
}

export async function getSavedConventionEvents(userId: string): Promise<ConventionEvent[]> {
  return runQuery(conventionsApi.endpoints.getSavedConventionEvents.initiate, userId);
}

export async function addConventionFavorite(conventionIdOrUserId: string, maybeConventionId?: string): Promise<unknown> {
  return runMutation(conventionsApi.endpoints.addConventionFavorite.initiate, { conventionIdOrUserId, maybeConventionId });
}

export async function removeConventionFavorite(userId: string, conventionId: string): Promise<unknown> {
  return runMutation(conventionsApi.endpoints.removeConventionFavorite.initiate, { userId, conventionId });
}

export async function updateConventionFavoriteReminder(
  conventionId: string,
  payload: { reminderEnabled?: boolean; reminderAt?: string; reminderLeadDays?: number },
): Promise<ConventionFavorite> {
  return runMutation(conventionsApi.endpoints.updateConventionFavoriteReminder.initiate, { conventionId, payload });
}
